module.exports = __webpack_public_path__ + "assets/888ddd2d95de085198c8369ca74ce348.png";